import styled from 'styled-components';
import { opacities } from '../../../defaultTheme';
export const TooltipArrow = styled.div `
  width: 14px;
  height: 14px;
  &:before {
    position: absolute;
    width: 14px;
    height: 14px;
    z-index: -1;
  }
  &:before {
    content: '';
    transform: rotate(45deg);
    background: ${({ theme }) => theme.tooltip.backgroundColor};
    border: ${({ hasBorder, theme }) => `${hasBorder ? 1 : 0}px solid ${theme.tooltip.borderColor}`};
  }
  &:after {
    content: '';
    position: absolute;
    z-index: -1;
    background: ${({ theme }) => theme.tooltip.backgroundColor};
  }
`;
export const TooltipContent = styled.div `
  min-width: 200px;
  max-width: 300px;
  background-color: ${({ theme }) => theme.tooltip.backgroundColor};
  border: ${({ hasBorder, theme }) => `${hasBorder ? 1 : 0}px solid ${theme.tooltip.borderColor}`};
  color: ${({ theme }) => theme.tooltip.color};
  font-size: inherit;
  line-height: inherit;
  border-radius: 10px;
  box-shadow: 0 11px 15px 0 ${opacities.rgbaLight10},
    0 9px 46px 8px ${opacities.rgbaLight08},
    0 24px 38px 3px ${opacities.rgbaLight04};

  &[data-popper-placement^='top'] > ${TooltipArrow} {
    bottom: -6px;
    &:after {
      width: 30px;
      height: 12px;
      bottom: 6px;
      left: -3px;
    }
  }
  &[data-popper-placement^='bottom'] > ${TooltipArrow} {
    top: -6px;
    &:after {
      width: 30px;
      height: 13px;
      top: 6px;
      left: -4px;
    }
  }
  &[data-popper-placement^='left'] > ${TooltipArrow} {
    right: -6px;
    &:after {
      width: 14px;
      height: 22px;
      top: -3px;
      right: 6px;
    }
  }
  &[data-popper-placement^='right'] > ${TooltipArrow} {
    left: -6px;
    &:after {
      width: 14px;
      height: 22px;
      top: -3px;
      left: 6px;
    }
  }
`;
export const TooltipTrigger = styled.div `
  display: inline-block;
  &:focus {
    outline: visible;
  }
`;
